<template>
  <div>
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: start;">
      <el-select size="small" v-model="system" placeholder="系统" @change="getLogs">
        <el-option
            v-for="item in systemList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
      </el-select>
      <el-select size="small" v-model="logLevel" placeholder="日志等级" @change="getLogs">
        <el-option
            v-for="item in logLevelList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
      </el-select>
    </div>
    <div style="text-align: left; font-size: 12px; line-height: 20px;word-break: break-all;" v-html="logContent">
    </div>
  </div>
</template>

<script>
export default {
  name: "ServerLog",
  data() {
    return {
      logContent: null,
      system: 'parse',
      systemList: [
        {
          value: 'parse',
          label: 'parse'
        },
        {
          value: 'CwHelper',
          label: 'CwHelper'
        }
      ],
      logLevel: 'error',
      logLevelList: [
        {
          value: 'error',
          label: 'error'
        },
        {
          value: 'warn',
          label: 'warn'
        },
        {
          value: 'info',
          label: 'info'
        }
      ],
    }
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    getLogs() {
      let that = this;
      this.$api
          .post('https://devmolv.com/' + this.system + '/admin/serverLog',
              {level: this.logLevel})
          .then(response => {
            if (response.data.resultCode === 0) {
              that.logContent = response.data.log.replace(/\n/g, "<br/><br/>");
            }
          });
    }
  }
};
</script>

<style>

</style>